import React from 'react'
import { connect } from 'react-redux'
import ButtonAction from "../components/ButtonAction"
import { List } from "immutable"
import styled from 'styled-components'
import {copyButtonActions, pasteButtonActions} from '../actions'
const StyledCurrentButton = styled.div
`
    float:left;
    padding:20px;
    width:80%;
    box-sizing:border-box;
    height:calc(65vh - 55px);
    overflow-y:auto;
`

const Title = styled.h1
`
    text-transform:uppercase;
`
const CopyButton = styled.button
    `
    text-transform:uppercase;
    cursor:pointer;
    background:#333;
    border:1px solid #666;
    padding:5px;
    transition:.5s all;
    border-radius:5px;
    margin:0 10px 0 0px;
    color: ${({disabled}) => (disabled ? '#666' : '#efefef')};

    &:hover{
    ${({disabled}) => !disabled && `
        background:#666;
    `}
    ${({disabled}) => disabled && `
        cursor:default;
    `}
    }

`
const CurrentButton = ({buttonID, preset, actions, clipboard, dispatch}) => {

    var actionUI = []
    actions.forEach(function(value, name){
        actionUI.push(<ButtonAction key={name} preset = {preset} buttonID = {buttonID} actionID={name} action={value}/>)

    })
    return(
        <StyledCurrentButton  className="currentButton" >
            <Title>button #{parseInt(buttonID) + 1}</Title>
            <CopyButton disabled = {false} onClick={()=>(dispatch(copyButtonActions(actions)))}>Copy</CopyButton>
            <CopyButton disabled = {!clipboard} onClick={()=>{if(clipboard){ dispatch(pasteButtonActions(preset, buttonID, clipboard))}}} >Paste</CopyButton>

            <ul>
                {actionUI}
            </ul>
        </StyledCurrentButton>
    );
};
const getCurrentButtonActions = (actions, preset, buttonID) => {
    console.log("current actions", actions)
    if (actions.has(preset) && actions.hasIn([preset, buttonID])) {
        return actions.getIn([preset, buttonID])
    }
    else{
        return List([])
    }
}

//const getClipboard = (actions) => {
//    if (actions.has('clipboard') && actions.get('clipboard') !== undefined) {
//        return actions.get('clipboard')
//    }
//    else{
//        return false
//    }
//}

function mapStateToProps(state){
    console.log("state",state)
    return{
        buttonID : state.buttons,
        preset : state.preset,
        actions : getCurrentButtonActions(state.buttonActions.present, state.preset, state.buttons),
        clipboard : state.clipboard
    }
}

export default connect(
    mapStateToProps
)(CurrentButton)